import { render, staticRenderFns } from "./index--detail.vue?vue&type=template&id=38cc44cc&scoped=true&"
import script from "./index--detail.vue?vue&type=script&lang=js&"
export * from "./index--detail.vue?vue&type=script&lang=js&"
import style0 from "./index--detail.vue?vue&type=style&index=0&id=38cc44cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc44cc",
  null
  
)

export default component.exports